<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import {ModelListSelect} from "vue-search-select";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/preloader";
import {mapGetters, mapActions, mapState} from "vuex";
import Swal from "sweetalert2";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Chart Of Accounts",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
    Loader,
  },
  data() {
    return {
      title: "Chart Of Accounts",
      items: [
        {
          text: "Home",
          href: "#/",
        },
        {
          text: "Chart Of Accounts",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "name",
          sortable: true,
          label: "ACCOUNT NAME",
        },
        {
          key: "code",
          sortable: true,
          label: "CODE",
        },
        {
          key: "type",
          sortable: true,
          label: "ACCOUNT TYPE",
        },
        {
          key: "sub_type",
          sortable: true,
          label: "SUB TYPE",
        },
        {
          key: "statement",
          sortable: true,
          label: "FINANCIAL STATEMENT",
        },
        {
          key: "user.names",
          sortable: true,
          label: "ADDED BY",
        },
        {
          key: "dateAdded",
          sortable: true,
          label: "ADDED ONs",
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],
      // Value from user input for adding category
      data: {
        name: "",
        code: "",
        type: "",
        sub_type: "0",
        statement: "",
        balance: "0",
      },
      // edit category
      editdata: {
        id: "",
        name: "",
        code: "",
        type: "",
        sub_type: "",
      },
      // make inputs required
      nameError: "",
      typeError: "",
      SubtypeError: "",
      // delete category
      deletedata: {
        name: "",
        id: "",
      },

      AccountTypes: [
        {name: "Asset", id: "1"},
        {name: "Liability", id: "2"},
        {name: "Equity", id: "3"},
        {name: "Revenue", id: "4"},
        {name: "Expense", id: "5"},
      ],

      json_fields: {
        NAME: "name",
        CODE: "code",
        TYPE: "type",
        STATEMENT: "statement",
        RECORDED_ON: "dateAdded",
      },
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
      modal_id: "" // Add modal_id to data
    };
  },
  computed: {
    // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
    ]),
    ...mapGetters("coa", ["Accounts", "AccountSaveStatus"]),
    ...mapGetters("auth", ["MyUserPerm"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.Accounts ? this.Accounts.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.Accounts ? this.Accounts.length : 1;
  },
  updated() {
  },

  watch: {
    show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        if (this.type == "success") {
          this.closeModal(this.modal_id);
          Swal.fire("Success!", this.message.msg, "success");
          // this.$toast.success(this.message.msg);
        } else {
          // this.$toast.error(this.message.msg);
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
  },

  methods: {
    ...mapActions({
      AddAccount: "coa/SaveAccount",
      EditAccount: "coa/EditAccount",
      DeleteAccount: "coa/DeleteAccount",
      FetchAccounts: "coa/fetchAccounts",
    }),

    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
            .toString()
            .replace(/[^0-9.]+/g, "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },

    /**
     * Search the table data with search input
     */

    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    setbalance() {
      this.data.balance = this.thousandSeperator(this.data.balance);
    },
    addAccount(modalId) {
      this.modal_id = modalId;

      if (this.data.name == "") {
        this.nameError = "Account Name field is required";
        return;
      } else {
        this.nameError = "";
      }
      if (this.data.type == "") {
        this.typeError = "Type field is required";
        return;
      } else {
        this.typeError = "";
      }
      if (this.data.sub_type == "") {
        this.SubtypeError = "Sub Type field is required";
        return;
      } else {
        this.SubtypeError = "";
      }
      if (this.data.type == 1 || this.data.type == 2 || this.data.type == 3) {
        this.data.statement = 1;
      } else if (this.data.type == 4 || this.data.type == 5) {
        this.data.statement = 2;
      }
      this.AddAccount(this.data);
    },
    resetAddAcc() {
      this.data.name = "";
      this.data.code = "";
      this.data.type = "";
      this.data.sub_type = "";
      this.data.statement = "";
      this.nameError = "";
      this.typeError = "";
      this.modal_id = "";
    },
    resetEditAcc() {
      this.editdata.name = "";
      this.editdata.code = "";
      this.editdata.type = "";
      this.editdata.sub_type = "";
      this.editdata.statement = "";
      this.editdata.id = "";
      this.modal_id = "";
    },
    resetDeleteAcc() {
      this.deletedata.name = "";
      this.deletedata.id = "";
      this.modal_id = "";
    },
    resetErrors() {
      this.nameError = "";
      this.typeError = "";
    },
    showEditModal(data) {
      this.editdata.name = data.item.name;
      this.editdata.code = data.item.code;
      this.editdata.type = data.item.type;
      this.editdata.sub_type = data.item.sub_type;
      this.editdata.id = data.item.id;
    },
    editAccount(modalId) {
      this.modal_id = modalId;
      if (this.editdata.type == 1 || this.editdata.type == 2 || this.editdata.type == 3) {
        this.editdata.statement = 1;
      } else if (this.editdata.type == 4 || this.editdata.type == 5) {
        this.editdata.statement = 2;
      }
      this.EditAccount(this.editdata);
    },
    showDeleteModal(data) {
      this.deletedata.name = data.item.name;
      this.deletedata.id = data.item.id;
    },
    async deleteAccount(modalId) {
      this.modal_id = modalId;
      await this.DeleteAccount(this.deletedata)
          .then(() => {
            this.closeModal(modalId);
          });
    },

    //== close modal
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
  },
  created() {
    this.FetchAccounts();
  },
};
</script>

<template>
  <Layout>
    <Toasts
        :show-progress="true"
        :rtl="true"
        :max-messages="20"
        :time-out="3000"
        :closeable="false"
        :solid="true"
    ></Toasts>
    <PageHeader :title="title" :items="items"/>

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-3">
                <download-excel
                    class="btn btn-info mt-4"
                    :data="Accounts"
                    :fields="json_fields"
                    :worksheet="'CHART OF ACCOUNTS'"
                    type="csv"
                    :name="'Chart of accounts'.xls"
                >
                  Export COA <i class="fa fa-file-excel"></i>
                </download-excel>
              </div>
              <div class="col-9">
                <b-button
                    class="float-end"
                    variant="primary"
                    v-b-modal.add-account-modal
                ><i class="fa fa-plus"></i> Record New Account
                </b-button
                >
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                        class="form-select form-select-sm"
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                  class="datatables"
                  :items="Accounts ? Accounts : []"
                  :fields="fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :sort-desc.sync="sortDesc"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(mode_field)="data">
                  {{ data.item.mode.name }} ({{ data.item.mode.type_name }}-{{ data.item.mode.account_number }})
                </template>
                <template #cell(actions)="data">
                  <b-button-group>
                    <b-button
                        v-if="data.item.generated_by == 1"
                        size="sm"
                        variant="primary"
                        v-b-modal.edit-account-modal
                        @click="showEditModal(data)"
                    ><i class="fa fa-edit"></i> Edit
                    </b-button
                    >
                    <b-button
                        size="sm"
                        variant="danger"
                        v-b-modal.delete-account-modal
                        @click="showDeleteModal(data)"
                    ><i class="fa fa-trash"></i> Delete
                    </b-button
                    >
                  </b-button-group>
                </template>
              </b-table>
            </div>
            <Loader v-if="!Accounts"/>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>

            <!-- add expense modal starts -->
            <b-modal id="add-account-modal" hide-footer @hidden="resetAddAcc">
              <template #modal-title> Record New Account</template>
              <div class="form-group mb-3">
                <label>Account Name</label>
                <div class="input-group">
                  <input
                      type="text"
                      class="form-control"
                      v-model="data.name"
                      @input="resetErrors()"
                      placeholder="Enter Account Name"
                  />
                </div>
                <div class="text-danger" v-if="nameError">
                  <em>{{ nameError }}</em>
                </div>
              </div>
              <div class="form-group mb-3">
                <label>Account Code</label>
                <div class="input-group">
                  <input
                      type="text"
                      class="form-control"
                      v-model="data.code"
                      @input="resetErrors()"
                      placeholder="Enter Account Name"
                  />
                </div>
              </div>
              <div class="form-group mb-3">
                <label>Account Type</label>
                <model-list-select
                    :list="AccountTypes ? AccountTypes : []"
                    v-model="data.type"
                    option-value="id"
                    option-text="name"
                    class="mb-3"
                    placeholder="Select Account Type"
                    @input="resetErrors()"
                >
                </model-list-select>
                <div class="text-danger" v-if="typeError">
                  <em>{{ typeError }}</em>
                </div>
              </div>
              <div class="form-group mb-3" v-if="data.type == 1">
                <label>Account Sub Type</label>
                <select
                    v-model="data.sub_type"
                    class="mb-3 form-control"
                    placeholder="Select Account Type"
                    @input="resetErrors()"
                >
                  <option value="0">Current Asset</option>
                  <option value="1">Fixed Asset</option>
                </select>
                <div class="text-danger" v-if="SubtypeError">
                  <em>{{ SubtypeError }}</em>
                </div>
              </div>
              <div class="form-group mb-3" v-if="data.type == 2">
                <label>Account Sub Type</label>
                <select
                    v-model="data.sub_type"
                    class="mb-3 form-control"
                    placeholder="Select Account Type"
                    @input="resetErrors()"
                >
                  <option value="0">Current Liability</option>
                  <option value="1">Long-term Liability</option>
                </select>
                <div class="text-danger" v-if="SubtypeError">
                  <em>{{ SubtypeError }}</em>
                </div>
              </div>
              <div class="form-group mb-3">
                <label>Current Balance</label>
                <div class="input-group">
                  <input
                      type="text"
                      @input="setbalance()"
                      class="form-control"
                      v-model="data.balance"
                      placeholder="Enter Account Balance"
                  />
                </div>
              </div>
              <div class="modal-footer">
                <button
                    type="button"
                    class="btn btn-danger"
                    data-dismiss="modal"
                    @click="closeModal('add-account-modal')"
                >
                  <i class="fa fa-times"></i> Close
                </button>
                <button
                    type="button"
                    class="btn btn-primary"
                    @click="addAccount('add-account-modal')"
                >
                  <i class="fa fa-check"></i> Save Account
                  <b-spinner
                      v-if="AccountSaveStatus"
                      variant="light"
                      small
                      label="Saving"
                  ></b-spinner>
                </button>
              </div>
            </b-modal>
            <!-- modal ends -->
            <!-- edit modal starts -->
            <b-modal id="edit-account-modal" hide-footer @hidden="resetEditAcc">
              <template #modal-title> Edit Account {{ editdata.name }}</template>
              <div class="form-group mb-3">
                <label>Accout Name</label>
                <div class="input-group">
                  <input
                      type="text"
                      class="form-control"
                      v-model="editdata.name"
                      @input="resetErrors()"
                      placeholder="Enter Account Name"
                  />
                </div>
                <div class="text-danger" v-if="nameError">
                  <em>{{ nameError }}</em>
                </div>
              </div>
              <div class="form-group mb-3">
                <label>Accout Code</label>
                <div class="input-group">
                  <input
                      type="text"
                      class="form-control"
                      v-model="editdata.code"
                      @input="resetErrors()"
                      placeholder="Enter Account Name"
                  />
                </div>
              </div>
              <div class="form-group mb-3">
                <label>Account Type</label>
                <model-list-select
                    :list="AccountTypes ? AccountTypes : []"
                    v-model="editdata.type"
                    option-value="id"
                    option-text="name"
                    class="mb-3"
                    placeholder="Select Account Type"
                    @input="resetErrors()"
                >
                </model-list-select>
                <div class="text-danger" v-if="typeError">
                  <em>{{ typeError }}</em>
                </div>
              </div>
              <div class="modal-footer">
                <button
                    type="button"
                    class="btn btn-danger"
                    data-dismiss="modal"
                    @click="closeModal('edit-account-modal')"
                >
                  <i class="fa fa-times"></i> Close
                </button>
                <button
                    type="button"
                    class="btn btn-primary"
                    @click="editAccount('edit-account-modal')"
                >
                  <i class="fa fa-check"></i> Save Changes
                  <b-spinner
                      v-if="AccountSaveStatus"
                      variant="light"
                      small
                      label="Saving"
                  ></b-spinner>
                </button>
              </div>
            </b-modal>
            <!-- modal ends -->

            <!-- modal delete expense starts -->
            <b-modal
                header-bg-variant="danger"
                header-text-variant="light"
                body-text-variant="danger"
                footer-bg-variant="danger"
                footer-text-variant="danger"
                id="delete-account-modal"
                hide-footer
                @hidden="resetDeleteAcc"
            >
              <template #modal-title> Delete Account {{ deletedata.name }}</template>
              <div class="form-group mb-3">
                <div class="input-group">
                  <h5>Do you want to delete this account? This is a permanent action.</h5>
                </div>
              </div>
              <div class="modal-footer">
                <button
                    type="button"
                    class="btn btn-secondary"
                    data-dismiss="modal"
                    @click="closeModal('delete-account-modal')"
                >
                  <i class="fa fa-times"></i> Close
                </button>
                <button
                    type="button"
                    class="btn btn-danger"
                    @click="deleteAccount('delete-account-modal')"
                >
                  <i class="fa fa-trash"></i> Proceed
                  <b-spinner
                      v-if="AccountSaveStatus"
                      variant="light"
                      small
                      label="Deleting"
                  ></b-spinner>
                </button>
              </div>
            </b-modal>
            <!-- modal ends -->
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style>
.btn-primary, .page-link {
  background-color: #FAB031 !important;
  border-color: #FAB031 !important;
}
</style>